import { hideLightingOverlay } from "../systems/lighting.js";
import { closeUI } from "../ui/memoryUI.js";
import { closeEscapeUI } from "../ui/escapeUI.js";
import { closeTextbox } from "../ui/textboxUI.js";
import { resetGameHud } from "../ui/gameHud.js";
import { hideCrosshairOverlay, removeCrosshairOverlay } from "../ui/crosshair.js";

const CREDITS_Z = 20;
const CREDITS_RAM_COUNT = 4;
const CREDITS_RAM_SCALE = 3;
const CREDITS_RAM_SPACING = 78;

function getCreditsRamPos(index) {
    const totalW = (CREDITS_RAM_COUNT - 1) * CREDITS_RAM_SPACING;
    return vec2(
        center().x - totalW / 2 + index * CREDITS_RAM_SPACING,
        center().y - 50,
    );
}

export function registerCreditsScene() {
    scene("credits", () => {
        hideLightingOverlay();
        resetGameHud();
        closeUI({ emit: false });
        closeEscapeUI();
        closeTextbox();
        hideCrosshairOverlay();
        removeCrosshairOverlay();

        add([
            rect(width(), height()),
            pos(0, 0),
            color(0, 0, 0),
            fixed(),
            z(CREDITS_Z),
        ]);

        add([
            text("PETA-BYTE", { font: "ShareTechMono", size: 32 }),
            pos(center().x, center().y - 118),
            anchor("center"),
            color(0, 255, 180),
            fixed(),
            z(CREDITS_Z + 1),
        ]);

        for (let i = 0; i < CREDITS_RAM_COUNT; i++) {
            add([
                sprite("ram_stick"),
                pos(getCreditsRamPos(i)),
                anchor("center"),
                scale(CREDITS_RAM_SCALE),
                color(255, 255, 255),
                fixed(),
                z(CREDITS_Z + 1),
            ]);
        }

        add([
            text("Created By:", { font: "ShareTechMono", size: 16 }),
            pos(center().x, center().y + 24),
            anchor("center"),
            color(255, 200, 100),
            fixed(),
            z(CREDITS_Z + 1),
        ]);

        add([
            text("Jaylen\nNam\nGiacomo", {
                font: "ShareTechMono",
                size: 18,
                lineSpacing: 10,
            }),
            pos(center().x, center().y + 86),
            anchor("center"),
            color(210, 230, 240),
            fixed(),
            z(CREDITS_Z + 1),
        ]);
    });
}
